import React, { Component } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  height: 70%;
  flex:1;
  position: relative;
  overflow: hidden;
  display: flex;
  cursor: pointer;
  background-color: ${props => props.isChecked ? '#3b99fc' : '#E0E0E0'};
  margin-left: 4px;
  margin-right: 4px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 4px;
  @media (max-width: 763px) {
    width: 55px;
  }
`
const Buttons = styled.button`
  color: ${props => props.isChecked ? '#FFF' : '#4A4A4A'};
  background-color: transparent;
  height: 100%;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border: solid 0.5px transparent;
`
const Input = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
`
export const Check = styled.img`
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-right: 10px;
    @media (max-width: 763px) {
      width: 15px;
      height: 15px;
    }
`
let extra = []
class CheckButton extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: false,
    }
  }

  componentWillMount() {
    extra = []
  }

  onClick = (e) => {
    const name = e.currentTarget.name
    const id = e.currentTarget.id
    if (e.currentTarget.checked == false) {
      extra.push(name)
      this.setState({ checked: true }, () => this.props.setInfo(extra, 'extra'))
    } else {
      for (let i = 0; i < extra.length; i++) {
        if (extra[i].cargo == name) {
          extra.splice(i, 1)
        }
      }
      this.setState({ checked: false }, () => this.props.setInfo(extra, 'extra'))
    }
  }


  render() {
    return (
      <Container isChecked={this.state.checked} >
        <Input
          ref={(input) => this.clickItem = input}
          onClick={this.onClick}
          id={this.props.label}
          name={this.props.name}
          checked={this.state.checked}
        />
        <Buttons onClick={() => this.clickItem.click()} isChecked={this.state.checked }>
          <Check src={this.state.checked ? "/assets/check.svg" : "/assets/checkmark.svg" } checked={this.state.checked}/>
          {this.props.label}
        </Buttons>
      </Container>
)
}
}

export default CheckButton



// WEBPACK FOOTER //
// ./src/Components/CustomButtons/CheckButton.jsx